import React from "react";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";

import fieldParser from "../FieldParser";
import FieldErrorTableInput from "../FieldErrorTableInput";
import FieldResolver from "../FieldResolver";
import { validator } from "../validation";

import "./TableFormGenerator.scss";
import FieldDisabled from "../FieldDisabled";

class TableFormGenerator extends React.Component {
  buildInputRow = (section, name, index) => {
    const { formApi } = this.props;
    let row = [];
    for (let i = 0; i < section.columns.length; i++) {
      let cellName = name + section.columns[i].column_name;
      let columnName = section.columns[i].column_name;
      let fieldArrayName = name.replace(/\[(.*)/, "");

      let disableField = section.columns[i].disableWhenField ? name + section.columns[i].disableWhenField : undefined;
      row.push(
        <FieldErrorTableInput
          returningToPage={this.props.returningToPage}
          field_name={cellName}
          field_array_name={fieldArrayName}
          column_name={columnName}
          index={index}
          currentErrors={this.props.currentErrors}
        >
          <Field
            tableName={name}
            name={cellName}
            validate={(values, allValues) =>
              section.columns[i].validate ? validator(section.columns[i].validate, allValues, index)(values) : undefined
            }
            parse={section.columns[i].parse ? fieldParser(section.columns[i].parse) : undefined}
            component={FieldResolver(section.columns[i].widget)}
            type={section.columns[i].widget}
            disabled={
              section.columns[i].disabled && disableField !== undefined
                ? FieldDisabled(section.columns[i].disabled, disableField, formApi)
                : section.columns[i].disabled
            }
            style={undefined}
            formApi={formApi}
            schemaProps={section.columns[i]}
            value={section.columns[i].choice || undefined}
            maxLength={section.columns[i].maxLength}
            showRequired={section.columns[i].validate && section.columns[i].validate[0] === "required"}
          />
        </FieldErrorTableInput>
      );
    }
    return row;
  };

  renderFieldArray = (section) => {
    let row = [];

    row.push(
      <FieldArray
        name={section.machine_name}
        section={section}
        validate={(values, allValues) =>
          section.validate ? validator(section.validate, allValues, null)(values) : undefined
        }
      >
        {({ fields }) =>
          fields.map((name, index) => (
            <tr id={`input_row`} key={name}>
              {this.buildInputRow(section, name, index)}
            </tr>
          ))
        }
      </FieldArray>
    );
    return row[0];
  };

  render() {
    const one = 1;

    let { section, formApi } = this.props;
    return (
      <div>
        {section.label ? <label className={`usa-label`}>{section.label}</label> : ""}
        <table style={{ border: one }} className="input-table">
          <thead>
            <tr>
              {section.columnHeaders.map((sectionHeader, i) => {
                return (
                  <th className="table-headers" key={i}>
                    {sectionHeader}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>{this.renderFieldArray(section)}</tbody>
        </table>
        {this.renderFieldsOnClickOr}
        <div className="table-btn-group">
          <button
            type="button"
            className="usa-button"
            onClick={() => formApi.mutators.push(section.machine_name, undefined)}
          >
            Add Row
          </button>
          <button
            type="button"
            className="usa-button usa-button--outline"
            onClick={() => formApi.mutators.pop(section.machine_name)}
          >
            Remove Last Row
          </button>
        </div>
      </div>
    );
  }
}

export default TableFormGenerator;
